import React from 'react';

import Base from './Base.jsx';

import AccountSecurity from '../Components/AccountSecurity/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs:account-security';
  }

  renderElement(element) {
    return (
      <AccountSecurity />
    );
  }
}


export default EntryPoint;

